import { render, staticRenderFns } from "./MerchantCorporateTable.vue?vue&type=template&id=f47f16ba&lang=pug"
import script from "./MerchantCorporateTable.vue?vue&type=script&lang=js"
export * from "./MerchantCorporateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports